import immutableUpdate from 'immutable-update'

const initialState = []

const reducers = {

  HYDRATE_NOTIFICATIONS: (state, action) => {

    const { notifications, reset } = action.payload

    if (reset) return [...notifications]
    const newState = [ ...notifications ]
    
    state.forEach(n => {

      if (newState.find(notification => notification.notificationId === n.notificationId)) return
      newState.push(n)
    })
    return newState
    // return [...new Set([...state, ...notifications])]
  },

  MARKASREAD_NOTIFICATION: (state, action) => {

    const { query } = action.payload
    const { notificationId, notifications } = query

    return state.map(notification => {

      let readed = notification.readed
      if (notificationId && notificationId === notification.notificationId) readed = true
      if (notifications) {
        const exits = notifications.indexOf(notification.notificationId)
        if (exits > -1) readed = true
      }

      return { 
        ...notification,
        readed: readed
      }
    })
  }

}

const notifications = (state = initialState, action) => reducers[action.type] ? 
  reducers[action.type](state, action)
  :
  [ ...state ]

export default notifications 